import { Link } from "react-router-dom";
import { useState, useContext, useEffect } from "react";
import { LanguageContext } from "../../utils/lang_provider";
import { fetchData } from "../../utils/fetch";
import { deleteData } from "../../utils/fetch";
import { message, Flex } from "antd";
import ContentTable from "./content/contentTable";

export function Dashboard() {
  const [dashboard, setDashboard] = useState([]);
  const { language } = useContext(LanguageContext)
  
  async function loadDashboard() {
      try {
          const data = await fetchData(`admin/dashboard`, language);
          setDashboard(data);
      } catch (error) {
          console.error('Error loading dashboard:', error);
      }
  }

  useEffect(() => {
    loadDashboard();
  }, [language, setDashboard]);

  const deleteEntry = async (type, id) => {
    try {
      const result = await deleteData(`admin/${type}/${id}`, language);
      message.success("Successfully deleted entry.");
      await loadDashboard();
      return result;
    } catch (error) {
      if (error.response?.status === 405 || error.status === 405) {
        message.error("Not authorized to delete this entry.");
      } else {
        message.error("Failed to delete entry: " + error.message);
      }
    }
  };

  return (
    <Flex vertical style={{margin: "0 5% 0 5%"}}>
      <ContentTable elements={dashboard} useType={true} type={null} deleteEntry={deleteEntry}></ContentTable>
    </Flex>
  )
}